import type { Table } from '@tanstack/react-table';

import { DownloadIcon } from '@radix-ui/react-icons';

import { Button } from '../../../components/Button';
import { exportTableToCSV } from '../utils/export';

interface TasksTableToolbarActionsProps {
  table: Table<any>;
  title?: string;
}

export function TasksTableToolbarActions({ table, title }: TasksTableToolbarActionsProps) {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={() =>
          exportTableToCSV(table, {
            filename: title || 'exportFile',
            excludeColumns: ['select', 'actions'],
          })
        }
      >
        <DownloadIcon className="mr-2 size-4" aria-hidden="true" />
        Export
      </Button>
      {}
    </div>
  );
}
